// extracted by mini-css-extract-plugin
export default {"other":"index_other_BFoYW","judgesImg":"index_judgesImg_ObCnh"};